import { library } from '@fortawesome/fontawesome-svg-core'
import { all } from '@awesome.me/kit-a9d8249218/icons'

library.add(...all)
